import React from "react";
import {
    SettingOutlined, BankFilled, ShoppingCartOutlined, TagsFilled, ShopOutlined,
    DropboxSquareFilled, SnippetsOutlined, ToolFilled, CalculatorOutlined,
    ContactsOutlined, UsergroupAddOutlined, IdcardOutlined, TeamOutlined,
    CheckCircleFilled, FundProjectionScreenOutlined, ExpandOutlined,
    EnvironmentOutlined, LineChartOutlined, AuditOutlined, SwapOutlined,
    FileTextOutlined,
} from "@ant-design/icons";

import IconCreditCard from "../../../../Icons/IconCreditCard";
import IconFileInvoice from "../../../../Icons/IconFileInvoice";
import IconClipBoardHeart from "../../../../Icons/IconClipBoardHeart";
import IconShoppingBag from "../../../../Icons/IconShoppingBag";
import IconBuildingWarehouse from "../../../../Icons/IconBuildingWarehouse";
import IconChecklist from "../../../../Icons/IconChecklist";
import IconAdjustmentsCog from "../../../../Icons/IconAdjustmentsCog";
import IconCalendarCheck from "../../../../Icons/IconCalendarCheck";
import IconBed from "../../../../Icons/IconBed";
import IconCartGarage from "../../../../Icons/IconCartGarage";
import { IconCMMS } from "../../../../Icons/IconosCMMS";

export const SECTION_TITLES = {
    general: "General",
    // Módulos del menú principal
    tesoreria: "Tesorería",
    pagos: "Pagos",
    cobranza: "Cobranza",
    compras: "Compras",
    medico: "Médico",
    ventas: "Ventas",
    puntoVenta: "Punto de Venta",
    insumos: "Insumos",
    activosFijos: "Activos Fijos",
    mantenimiento: "CMMS",
    inventario: "Inventario",
    conteos: "Conteos",
    consignaciones: "Consignaciones",
    produccion: "Producción",
    procesos: "Procesos",
    preciosUnitarios: "Precios Unitarios",
    clientes: "Clientes",
    crm: "CRM",
    proveedores: "Proveedores",
    capitalHumano: "Capital Humano",
    controlAsistencia: "Control de Asistencia",
    calidad: "Módulo de Calidad",
    contabilidad: "Contabilidad",
    finanzas: "Finanzas",
    negocio: "Negocio",
    wms: "WMS",
    hotel: "Hotel",
    envios: "Transporte",
    mezcal: "Mezcal",
    reportes: "Reportes",
    auditoria: "Auditoría",
    // Configuración transversal
    dropshipping: "Integraciones",
    pdf: "Opciones de impresión",
};

export const MENU_ITEMS = [
    { key: "general", icon: <SettingOutlined />, label: "General" },

    // Módulos, en el orden del menú principal
    { key: "tesoreria", icon: <BankFilled />, label: "Tesorería" },
    { key: "pagos", icon: <IconCreditCard />, label: "Pagos" },
    { key: "cobranza", icon: <IconFileInvoice />, label: "Cobranza" },
    { key: "compras", icon: <ShoppingCartOutlined />, label: "Compras" },
    { key: "medico", icon: <IconClipBoardHeart />, label: "Médico" },
    { key: "ventas", icon: <TagsFilled />, label: "Ventas" },
    { key: "puntoVenta", icon: <IconShoppingBag />, label: "Punto de Venta" },
    { key: "insumos", icon: <ShopOutlined />, label: "Insumos" },
    { key: "activosFijos", icon: <IconBuildingWarehouse />, label: "Activos Fijos" },
    { key: "mantenimiento", icon: <IconCMMS />, label: "CMMS" },
    { key: "inventario", icon: <DropboxSquareFilled />, label: "Inventario" },
    { key: "conteos", icon: <IconChecklist />, label: "Conteos" },
    { key: "consignaciones", icon: <SnippetsOutlined />, label: "Consignaciones" },
    { key: "produccion", icon: <ToolFilled />, label: "Producción" },
    { key: "procesos", icon: <IconAdjustmentsCog />, label: "Procesos" },
    { key: "preciosUnitarios", icon: <CalculatorOutlined />, label: "Precios Unitarios" },
    { key: "clientes", icon: <ContactsOutlined />, label: "Clientes" },
    { key: "crm", icon: <UsergroupAddOutlined />, label: "CRM" },
    { key: "proveedores", icon: <IdcardOutlined />, label: "Proveedores" },
    { key: "capitalHumano", icon: <TeamOutlined />, label: "Capital Humano" },
    { key: "controlAsistencia", icon: <IconCalendarCheck />, label: "Control Asis." },
    { key: "calidad", icon: <CheckCircleFilled />, label: "Calidad" },
    { key: "contabilidad", icon: <BankFilled />, label: "Contabilidad" },
    { key: "finanzas", icon: <FundProjectionScreenOutlined />, label: "Finanzas" },
    { key: "negocio", icon: <ExpandOutlined />, label: "Negocio" },
    { key: "wms", icon: <EnvironmentOutlined />, label: "WMS" },
    { key: "hotel", icon: <IconBed />, label: "Hotel" },
    { key: "envios", icon: <IconCartGarage />, label: "Transporte" },
    { key: "mezcal", icon: <ShoppingCartOutlined />, label: "Mezcal" },
    { key: "reportes", icon: <LineChartOutlined />, label: "Reportes" },
    { key: "auditoria", icon: <AuditOutlined />, label: "Auditoría" },

    { type: "divider" },
    { key: "dropshipping", icon: <SwapOutlined />, label: "Integraciones" },
    { key: "pdf", icon: <FileTextOutlined />, label: "PDF General" },
];

// Módulos sin opciones propias cuya configuración vive en otro lado. La pista
// se muestra en el aviso de la sección libre.
export const PISTAS_SECCION_LIBRE = {
    contabilidad: "Las opciones de pólizas están en Finanzas › Polizas, que es donde vive esa pantalla en el menú.",
    inventario: "Las opciones de inventario están en Lotes y en Movimientos Inventario.",
    pagos: "Las opciones de cuentas por pagar están en Pagos › Cuentas por Pagar.",
    proveedores: "La evaluación de proveedores se configura en Proveedores › Evaluación.",
    clientes: "El complemento de escuela se configura en Clientes › Escuela.",
    finanzas: "Las opciones de pólizas están en Finanzas › Polizas.",
};

// Segundo nivel de navegación: calca las pantallas del menú principal. La que
// se llama igual que el módulo es la portada y no se repite; se llega a ella
// con clic en el renglón del módulo.
//
// `navLabel` es el texto corto del menú, `label` el que se muestra en el header.
export const SUBSECCIONES = {
    tesoreria: [
        { key: "bancos", label: "Bancos" },
        { key: "cajaEfectivo", label: "Caja y Efectivo" },
        { key: "creditos", label: "Créditos" },
    ],
    pagos: [
        { key: "cuentasPorPagar", label: "Cuentas por Pagar" },
        { key: "abonosProveedor", label: "Abonos Proveedor" },
    ],
    cobranza: [
        { key: "cuentasPorCobrar", label: "Cuentas por Cobrar" },
        { key: "abonosCliente", label: "Abonos Cliente" },
        { key: "cobros", label: "Cobros" },
        { key: "programarRecordatorios", label: "Programar recordatorios", navLabel: "Recordatorios" },
    ],
    compras: [
        { key: "requisiciones", label: "Requisiciones" },
        { key: "workbenchRequisiciones", label: "WorkBench Requisiciones", navLabel: "WorkBench Req." },
        { key: "sugerenciasRequisicion", label: "Sugerencias de Requisición", navLabel: "Sugerencias Req." },
        { key: "ordenesCompra", label: "Ordenes de Compra" },
        { key: "facturasSinOC", label: "Facturas sin Orden de Compra", navLabel: "Facturas sin OC" },
        { key: "remisiones", label: "Remisiones" },
        { key: "facturasCajaChica", label: "Facturas Caja Chica" },
        { key: "facturas", label: "Facturas" },
        { key: "notasCreditoCompra", label: "Notas de Crédito Compra", navLabel: "Notas de Crédito" },
        { key: "devolucionesCompra", label: "Devoluciones Compra", navLabel: "Devoluciones" },
        { key: "comodato", label: "Comodato" },
        { key: "leerXml", label: "Leer Xml" },
        { key: "prorrateos", label: "Prorrateos" },
        { key: "pdf", label: "PDF de Compras", navLabel: "PDF", icon: <FileTextOutlined /> },
    ],
    medico: [
        { key: "pacientes", label: "Pacientes" },
        { key: "doctores", label: "Doctores" },
        { key: "cirugias", label: "Cirugias" },
        { key: "emergencias", label: "Emergencias" },
    ],
    ventas: [
        { key: "embarques", label: "Embarques" },
        { key: "pedidos", label: "Pedidos" },
        { key: "cotizaciones", label: "Cotizaciones" },
        { key: "cotizadorInsumo", label: "Cotizador por Insumo", navLabel: "Cotizador Insumo" },
        { key: "preCotizacion", label: "Pre Cotización" },
        { key: "ecommerce", label: "Ventas eCommerce", navLabel: "eCommerce" },
        { key: "ventasProgramadas", label: "Ventas Programadas", navLabel: "Programadas" },
        { key: "canales", label: "Canales" },
        { key: "facturas", label: "Facturas de Venta", navLabel: "Facturas" },
        { key: "facturasGlobales", label: "Facturas Globales", navLabel: "Fact. Globales" },
        { key: "notasCreditoVenta", label: "Notas de Crédito Venta", navLabel: "Notas de Crédito" },
        { key: "devolucionesVenta", label: "Devoluciones Venta", navLabel: "Devoluciones" },
        { key: "series", label: "Series y Folios Personalizados", navLabel: "Series y Folios" },
        { key: "kiosco", label: "Kiosco" },
        { key: "vencimientos", label: "Días de vencimiento", navLabel: "Vencimientos" },
        // Lleva icono a propósito: el usuario podría ir a buscarla a "PDF General".
        { key: "pdf", label: "PDF de Ventas", navLabel: "PDF", icon: <FileTextOutlined /> },
    ],
    puntoVenta: [
        { key: "cajas", label: "Cajas" },
        { key: "sesiones", label: "Sesiones" },
    ],
    insumos: [
        { key: "servicios", label: "Servicios" },
        { key: "insumosCompuestos", label: "Insumos Compuestos", navLabel: "Compuestos" },
        { key: "activos", label: "Activos" },
        { key: "familias", label: "Familias" },
        { key: "tiposInsumos", label: "Tipos De Insumos" },
        { key: "marcas", label: "Marcas" },
        { key: "unidades", label: "Unidades" },
        { key: "listasPrecios", label: "Listas de Precios" },
    ],
    activosFijos: [
        { key: "tiposActivo", label: "Tipos de Activo" },
        { key: "activos", label: "Activos" },
        { key: "inventarioActivos", label: "Inventario de Activos", navLabel: "Inventario" },
        { key: "movimientos", label: "Movimientos" },
        { key: "depreciaciones", label: "Depreciaciones" },
    ],
    mantenimiento: [
        { key: "servicios", label: "Servicios" },
        { key: "tickets", label: "Tickets" },
        { key: "activos", label: "Activos" },
        { key: "tiposActivo", label: "Tipos de Activo" },
        { key: "rutinas", label: "Rutinas" },
        { key: "configuracion", label: "Configuración" },
    ],
    inventario: [
        { key: "lotes", label: "Lotes" },
        { key: "agrupaciones", label: "Agrupaciones" },
        { key: "traspasoAlmacenes", label: "Traspaso Almacenes", navLabel: "Traspasos" },
        { key: "controlInventario", label: "Control Inventario" },
        { key: "movimientosInventario", label: "Movimientos Inventario", navLabel: "Movimientos" },
        { key: "agregarInventario", label: "Agregar Inventario" },
        { key: "productosAlCosto", label: "Productos Al Costo" },
    ],
    conteos: [
        { key: "conteosCiclicos", label: "Conteos cíclicos" },
        { key: "ordenesConteo", label: "Ordenes de Conteo" },
    ],
    consignaciones: [
        { key: "inventarioConsignaciones", label: "Inventario Consignaciones", navLabel: "Inventario" },
        { key: "ventas", label: "Ventas" },
        { key: "bajasConsignaciones", label: "Bajas Consignaciones", navLabel: "Bajas" },
    ],
    produccion: [
        { key: "listaMateriales", label: "Lista de Materiales" },
    ],
    procesos: [
        { key: "dashboard", label: "Dashboard" },
        { key: "etapas", label: "Etapas" },
    ],
    preciosUnitarios: [
        { key: "presupuestos", label: "Presupuestos" },
        { key: "matrices", label: "Matrices" },
        { key: "intangibles", label: "Intangibles" },
    ],
    clientes: [
        { key: "tipoClientes", label: "Tipo de Clientes" },
        { key: "portalClientes", label: "Portal Clientes" },
        { key: "escuela", label: "Escuela" },
    ],
    crm: [
        { key: "miTablero", label: "Mi tablero" },
        { key: "miCalendario", label: "Mi Calendario" },
        { key: "reportes", label: "Reportes" },
    ],
    proveedores: [
        { key: "tipoProveedores", label: "Tipo de Proveedores" },
        { key: "relacionInsumoProveedor", label: "Relación Insumo - Proveedor", navLabel: "Insumo - Proveedor" },
        { key: "evaluacionProveedores", label: "Evaluación de Proveedores", navLabel: "Evaluación" },
    ],
    capitalHumano: [
        { key: "empleados", label: "Empleados" },
        { key: "departamentos", label: "Departamentos" },
        { key: "vacaciones", label: "Vacaciones" },
        { key: "puestos", label: "Puestos" },
        { key: "preNomina", label: "Pre-Nomina" },
        { key: "creditosMovimientos", label: "Creditos y Movimientos", navLabel: "Créditos y Mov." },
        { key: "recibos", label: "Recibos" },
        { key: "reportes", label: "Reportes" },
        { key: "generarAguinaldo", label: "Generar Aguinaldo", navLabel: "Aguinaldo" },
        { key: "configuracion", label: "Configuración" },
    ],
    controlAsistencia: [
        { key: "relojesChecadores", label: "Relojes Checadores" },
        { key: "asignacionRelojes", label: "Asignación de Relojes", navLabel: "Asig. Relojes" },
        { key: "asistencia", label: "Asistencia" },
        { key: "horarios", label: "Horarios" },
        { key: "descansos", label: "Descansos" },
        { key: "turnos", label: "Turnos" },
        { key: "asignacionTurnos", label: "Asignación de Turnos", navLabel: "Asig. Turnos" },
        { key: "calendarioEmpleado", label: "Calendario Empleado" },
        { key: "primeroUltimo", label: "Primero & Ultimo" },
        { key: "asistenciaDiaria", label: "Asistencia Diaria" },
        { key: "empEnSitio", label: "Emp. en Sitio" },
        { key: "totalAsistencia", label: "Total Asistencia" },
        { key: "configuracionAsis", label: "Configuración Asis." },
    ],
    contabilidad: [
        { key: "cuentasContables", label: "Cuentas Contables" },
        { key: "tipoPolizas", label: "Tipo de Polizas" },
        { key: "tipoEgresos", label: "Tipo de Egresos" },
        { key: "tipoFlujos", label: "Tipo de Flujos" },
        { key: "impuestos", label: "Impuestos" },
        { key: "retenciones", label: "Retenciones" },
    ],
    finanzas: [
        { key: "presupuestos", label: "Presupuestos" },
        { key: "subProyectos", label: "SubProyectos" },
        { key: "polizas", label: "Polizas" },
        { key: "plantillasPolizas", label: "Plantillas Polizas" },
        { key: "cargoAbonos", label: "Cargo Abonos" },
        { key: "reclasificarMovimientos", label: "Reclasificar Movimientos", navLabel: "Reclasificar Mov." },
    ],
    negocio: [
        { key: "unidadesNegocio", label: "Unidades de Negocio" },
        { key: "proyectosAlmacenes", label: "Proyectos / Almacenes" },
    ],
    wms: [
        { key: "ubicaciones", label: "Ubicaciones" },
        { key: "mapa", label: "Mapa" },
    ],
    hotel: [
        { key: "mapaHotel", label: "Mapa de Hotel" },
    ],
    envios: [
        { key: "vehiculos", label: "Vehículos" },
        { key: "rendimientoVehiculos", label: "Rendimiento Vehículos", navLabel: "Rendimiento" },
        { key: "polizasSeguro", label: "Polizas de Seguro" },
        { key: "remolques", label: "Remolques" },
    ],
    mezcal: [
        { key: "registroLotes", label: "Registro de Lotes" },
        { key: "cortePinas", label: "Corte de Piñas" },
        { key: "horneado", label: "Horneado" },
        { key: "fermentacion", label: "Fermentacion" },
        { key: "primeraDestilacion", label: "Primera Destilacion", navLabel: "1a Destilación" },
        { key: "segundaDestilacion", label: "Segunda Destilacion", navLabel: "2a Destilación" },
        { key: "terceraDestilacion", label: "Tercera Destilacion", navLabel: "3a Destilación" },
        { key: "tanquesLlenado", label: "Tanques de Llenado" },
    ],
    auditoria: [
        { key: "bitacoraActividad", label: "Bitácora de Actividad", navLabel: "Bitácora" },
        { key: "historialCorreos", label: "Historial de Correos" },
    ],
};
